import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

interface WarningModalProps {
  showWarning: false | 'less' | 'more';
}

const StyledDiv = styled.div`
  text-align: center;
  margin-top: ${SPACERS.large};
  .warning-modal-heading {
    margin-bottom: ${SPACERS.medium};
  }
  .warning-modal-subheading {
    max-width: 503px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${SPACERS.medium};
  }
`;

const WarningModal: React.FC<WarningModalProps> = ({ showWarning }) => {
  if (showWarning === 'more') {
    return (
      <StyledDiv>
        <TrueImpactText variant="heading" className="warning-modal-heading">
          Looks like you selected a full year or longer.
        </TrueImpactText>
        <TrueImpactText className="warning-modal-subheading">
          Is this correct? You indicated that you need to report over a period
          shorter than a full year on the previous screen. If this isn’t the
          case, we will use your selected dates as the standard annual reporting
          schedule for this report and all future reports for this program.
        </TrueImpactText>
      </StyledDiv>
    );
  }
  return (
    <StyledDiv>
      <TrueImpactText variant="heading" className="warning-modal-heading">
        Looks like you selected a period of less than a year.
      </TrueImpactText>
      <TrueImpactText className="warning-modal-subheading">
        Is this correct? You indicated that you need to report over a period
        greater than a year on the previous screen. If this isn’t the case, we
        will use your selected dates as the standard reporting schedule for this
        report and all future reports for this program.
      </TrueImpactText>
    </StyledDiv>
  );
};

export default WarningModal;
